import { render } from "./SendDotations.vue?vue&type=template&id=2ebe5116&scoped=true&ts=true"
import script from "./SendDotations.vue?vue&type=script&lang=ts"
export * from "./SendDotations.vue?vue&type=script&lang=ts"

import "./SendDotations.vue?vue&type=style&index=0&id=2ebe5116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebe5116"]])

export default __exports__